import React from "react";

import { A } from "./styles/Tracker.styles";

const TrackerAnchor = (props: any) => (
  <A
    {...props}
    onClick={(ev: any) => {
      ev.stopPropagation();
      if (props.onClick) props.onClick();
    }}
  />
);

export default TrackerAnchor;